import React from 'react';
import { useAuth } from '../../context/AuthContext';
import BranchSelectionDialog from './BranchSelectionDialog';

/**
 * A wrapper component that handles displaying the branch selection dialog
 * at the application level, ensuring it appears when needed
 */
const BranchSelectionWrapper: React.FC = () => {
  const { user, showBranchDialog, setActiveBranch } = useAuth();

  // Handle branch selection
  const handleBranchSelect = (branchId: string) => {
    setActiveBranch(branchId);
  };

  if (!showBranchDialog || !user?.accessibleBranches || user.accessibleBranches.length === 0) {
    return null;
  }

  return (
    <BranchSelectionDialog
      open={true}
      branches={user.accessibleBranches}
      onSelect={handleBranchSelect}
      defaultBranch={user.defaultBranch?._id}
    />
  );
};

export default BranchSelectionWrapper;